import React from 'react';
import SelectFilter from '../../../../components/Select/SelectFilter';

const SelectDetail = (props) => (
  <SelectFilter
    dropdownProps={{
      styles: `margin-top:15px`,
      colorIcon: 'rgba(226,93,52,1)'
    }}
    minWidth={props.minWidth ? props.minWidth : '275px'}
    minHeight={props.minHeight ? props.minHeight : 'auto'}
    display={props.display ? props.display : 'block'}
    alignItems={props.alignItems ? props.alignItems : 'none'}
    containerStyles={`.label{color:${
      props.colorLabel ? props.colorLabel : '#e25c32'
    };margin-bottom:2vh}`}
    customStyles={{
      container: {
        height: 'auto',
        minHeight: 25
      },
      control: {
        border: 0,
        borderBottom: '0',
        width: '100%',
        fontFamily: 'SilkSerifRegular',
        backgroundColor: 'transparent',
        height: '35px',
        minHeight: '25px',
        justifyContent: 'initial'
      },
      valueContainer: {
        paddingLeft: 0,
        marginLeft: 0,
        color: 'white',
        height: '100%',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'row',
        maxWidth: 'initial',
        flex: 'initial'
      },
      singleValue: {
        color: props.colorValue ? props.colorValue : 'white',
        fontFamily: 'SilkSerifRegular',
        maxWidth: '100%',
        textEllipsis: 'none',
        fontSize: props.fontSize ? 'calc(' + props.fontSize + 'px)' : '23px',
        transform: 'initial',
        position: 'static',
        top: 'auto',
        marginTop: 15
      },
      placeholder: {
        fontStyle: 'normal',
        color: 'white',
        opacity: 0.8
      },
      option: props.standardOptionsStyle
        ? {}
        : {
            backgroundColor: '#1a1f24',
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.60)' },
            fontFamily: 'SilkSerifRegular'
          },
      menuList: props.standardOptionsStyle
        ? {}
        : {
            backgroundColor: 'rgba(0, 0, 0, 0.53)',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.53)' }
          }
    }}
    isClearable={false}
    {...props}
  />
);

export default SelectDetail;
